import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Checkbox, RadioButtons } from "@swivl-mono/ui";
import { CheckedState } from "@radix-ui/react-checkbox";
import React from "react";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const ValidateNormalize = {
  Type: "validateNormalize",
  Empty: function () {
    return {
      id: RandomId(6),
      type: ValidateNormalize.Type,
      inputValue: "",
      expectedType: "name", // Default to name
      saveToVariableId: "", // Default to empty (no variable selected)
      validGoto: null,
      invalidGoto: null,
    };
  },

  PlumbData: function (node: NodeInterface) {
    const inputDisplay = node.inputValue && node.inputValue.length > 0 
      ? VarsModel.replaceVariableNameInString(node.inputValue, "*", "*")
      : "No input";
    
    const displayText = inputDisplay.length > 25 ? inputDisplay.substring(0, 22) + "..." : inputDisplay;

    return TabNodeLayoutData({
      node: node,
      label: "Validate & Normalize",
      title: node.expectedType ? node.expectedType.toUpperCase() : "NAME",
      body: displayText,
      baseWidth: 200,
      tabs: [
        {
          id: "validGoto",
          source: "validGoto",
          target: node.validGoto,
          title: "Valid",
        },
        {
          id: "invalidGoto", 
          source: "invalidGoto",
          target: node.invalidGoto,
          title: "Invalid",
        },
      ],
    });
  },

  InspectorPanel: class ValidateNormalizeInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);
      this.updateExpectedType = this.updateExpectedType.bind(this);
      this.saveToggled = this.saveToggled.bind(this);
    }

    updateExpectedType(event: any) {
      const newType = event.target.value;
      let node = JSON.parse(JSON.stringify(this.props.node));
      node.expectedType = newType;
      // Reset goto paths when type changes
      node.validGoto = "";
      node.invalidGoto = "";
      this.props.updateNode(node, this.props.node, true);
    }

    saveToggled(checked: CheckedState) {
      if (!checked) {
        this.onChangeUpdateAndRedraw({ target: { name: "saveToVariableId", value: "" } });
        return;
      }

      let vars = VarsModel.variableOptions(true);

      if (!vars || vars.length === 0) {
        alert("User Variables Not Loaded");
        return;
      }

      // Set a default variable based on expected type
      let defaultVar;
      for (let i = 0; i < vars.length; i++) {
        const val = vars[i].value;
        if (
          (val === "User:Name" && this.props.node.expectedType === "name") ||
          (val === "User:Email" && this.props.node.expectedType === "email") ||
          (val === "User:PhoneNumber" && this.props.node.expectedType === "phone") ||
          (val === "User:PostalCode" && this.props.node.expectedType === "zip")
        ) {
          defaultVar = vars[i].value;
          break;
        }
      }

      if (!defaultVar) {
        defaultVar = vars[0].value;
      }

      this.onChangeUpdateAndRedraw({ target: { name: "saveToVariableId", value: defaultVar } });
    }

    render() {
      const { node } = this.props;
      
      // Variable saving UI
      const isSaveTo = node.saveToVariableId && node.saveToVariableId.length > 0;
      const saveToCheckbox = (
        <div className="urlTarget">
          <span>Save normalized value to variable</span>
          <Checkbox onCheckedChange={this.saveToggled} checked={isSaveTo} />
        </div>
      );

      const saveToDropdown = isSaveTo ? (
        <UserVariablesDropdown
          onChange={this.onChange}
          skipUserId={true}
          name="saveToVariableId"
          value={node.saveToVariableId}
        />
      ) : null;

      return (
        <div>
          <div className="panel message_panel">
            <InspectorNodeHeader title="Validate & Normalize" />
            
            <div className="panelRow">
              <label>Input to validate:</label>
              <TagInput
                type={TagInputType.SingleLine}
                value={node.inputValue || ""}
                onChange={this.onChange}
                name="inputValue"
                placeholder="Enter text"
              />
            </div>

            <div className="panelRow">
              <label>Expected type:</label>
              <RadioButtons
                options={[
                  { value: "name", label: "Name" },
                  { value: "email", label: "Email" },
                  { value: "phone", label: "Phone" },
                  { value: "zip", label: "ZIP/Postal Code" },
                ]}
                name="expectedType"
                value={node.expectedType || "name"}
                onChange={this.updateExpectedType}
              />
            </div>

            {saveToCheckbox}
            {saveToDropdown}
          </div>
          
          <div className="carouselPadding"></div>
          <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
        </div>
      );
    }
  },
};

export default ValidateNormalize;